import { DataSource, DataSourceOptions } from 'typeorm'; 
import { formatDate, importTrLine,importOpeningBalance, importAccount, importPeriod, importBasic, importCustomersupplier} from './import';
import { getCookie } from './utils';
var statusMessages = [];
export async function fetchMetadata(config){
  try{
    var response = await fetch('http://localhost:3443/api/metadata',{
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(config),
    });
    var responseData = await response.text();

    if(response.status == 200 && responseData){
      return responseData;
    }
    else{
      return false;
    }
  } 
  catch(error){
    return false;
  }
}
export async function connect(config){
  try{
    var response = await fetch('http://localhost:3443/api/connect',{
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(config),
    });
    var responseData = await response.text();
    console.log(responseData);
    if(response.status == 200 && responseData){
      console.log(await fetchMetadata(config));
      return true;
    }
    else{
        alert('Ongeldige gegevens! Controleer je authenticatie gevens en probeer het opnieuw.');
        return false;
    }
  } 
  catch(error){
    console.log(error);
    alert('Backend service niet gevonden! Controleer het poortnummer.');
    return false;
  }
}
export async function validate(){
  try{
    var response = await fetch('http://localhost:3443/api/validate',{
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if(response.status == 200){
      var responseData = await response.text();
      console.log(responseData);
      if(responseData){
        return true;
      }
      else{
        return false;
      }
    }
    else{
      return false;
    }
  } 
  catch(error){
    // Optional: Log the error or inspect it for debugging
    console.error('Fetch error:', error.message || error);

    // If you want to specifically detect connection refused errors:
    if (error.code === 'ECONNREFUSED' || error.message.includes('ECONNREFUSED')) {
      console.warn('Connection refused to localhost:3443');
    }
    return false;
  }
}
export async function test2(){
  try{
    var response = await fetch('http://localhost:3443/api/test',{
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ year: 2010 }),
    })
    var responseData = await response.json();
  } 
  catch(error){
    return false;
  }
}

// Function to establish a connection to the database
export async function getConnection(clientConfig) {
  try{
    const response = await fetch('http://localhost:3443/api/get_connection', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: clientConfig,
    })
    if (response.ok) {
      const responseData = await response.json();
      return responseData;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}

//Submits import exact updates/changes
export async function updateImportExactGlobe(id, openingBalance, ignoreYearEnd){
  try{
    const response = await fetch('/import_exactglobe/updateImport', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: id,
        openingBalance: openingBalance,
        ignoreYearEnd: ignoreYearEnd,
      }),
    })
    if (response.ok) {
      const responseData = await response.json();
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}

async function createImp(entiteit, year){
  try{
    const response = await fetch('/exactglobe/createImp', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        entiteit: entiteit,
        year: year,
        factviewAccess: getCookie("factview_access"),
      }),
    })
    if (response.ok) {
      const responseData = await response.json();
      return responseData;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}

async function getImportExactGlobe(entiteit, year, budgetScenario){
  try{
    const response = await fetch('/import_exactglobe/getImportExactGlobe', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        entiteit: entiteit,
        year: year,
        budget_scenario: budgetScenario,
        exactglobe_token: getCookie("ExactGlobeToken"),
      }),
    })
    if (response.ok) {
      const responseData = await response.json();
      return responseData;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}

async function updateImpid(impid, entiteit, year, budgetScenario){
  try{
    const response = await fetch('/import_exactglobe/updateImpid', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        impid: impid,
        entiteit: entiteit,
        year: year,
        budget_scenario: budgetScenario,
        exactglobe_token: getCookie("ExactGlobeToken"),
      }),
    })
    if (response.ok) {
      const responseData = await response.json();
      return responseData;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}

// Delete import exact by id
export async function deleteImport(id){
  try {  
    const importResponse = await fetch('/import_exactglobe/getById?id='+id);
    if(importResponse.ok){
      const importData = await importResponse.json();

      // await clearExistingScheduledImports({"import_type": "exactonline", "entiteit": importData["entiteit"], "year": importData["year"],"office": importData["office"], "budget_scenario": importData["budget_scenario"]})
    
      const response = await fetch('/import_exactglobe/deleteImport?id='+id);
      if (response.ok) {
      const responseData = await response.json();
      
      if(responseData){
      }
    }
    
  }
  } catch (error) {
    console.error('Error deleting data:', error);
  }
}

export async function handleImport(data, updateStatus){
  statusMessages = [];
  const case_id = data["entiteit"].substring(0, data["entiteit"].indexOf('_'));
  
  var importExactGlobe = await getImportExactGlobe(data["entiteit"], data["year"], data["budget_scenario"], data["exactglobe_token"]);
  if(importExactGlobe.impid == 0){
    const imp = await createImp(data["entiteit"], data["year"]);

    importExactGlobe = await updateImpid(imp["id"], data["entiteit"], data["year"], data["budget_scenario"]);
  }

  statusMessages.push({"text": "Initiating Exact Globe import!", "progress": 1, "status": 1});
  updateStatus([...statusMessages]);

  await initImport(case_id, importExactGlobe["impid"], getCookie("factview_access"));

  statusMessages.push({"text": "Fetching TrLines", "progress": 10, "status": 1});
  updateStatus([...statusMessages]);

  var trLines = await handleTrLines(case_id, data["year"], importExactGlobe["impid"], importExactGlobe["ignore_year_end"], updateStatus);
 
  await importTrLine(case_id, trLines);
  
  statusMessages.push({"text": "TrLines lines processed: " + trLines.length, "progress": 25, "status": 1});
  updateStatus([...statusMessages]);
  
  // if(data["opening_balance"]){
  //   var obLines = await handleOpeningBalance(data["year"], importExactGlobe["impid"], data["entiteit"]);
  //   await importOpeningBalance(case_id, obLines);
  // }
  
  statusMessages.push({"text": "Fetching Account", "progress": 30, "status": 1});
  updateStatus([...statusMessages]);
  
  var account = await handleAccount(importExactGlobe["impid"], updateStatus);
  
  await importAccount(case_id, account);
  
  statusMessages.push({"text": "Account records processed:" + account.length, "progress": 40, "status": 1});
  updateStatus([...statusMessages]);

  statusMessages.push({"text": "Fetching period", "progress": 45, "status": 1});
  updateStatus([...statusMessages]);
  
  var period = await handlePeriod(data["year"], importExactGlobe["impid"],updateStatus);
  await importPeriod(case_id, period);
 
  statusMessages.push({"text": "Period records processed:" + period.length, "progress": 60, "status": 1});
  updateStatus([...statusMessages]);

  statusMessages.push({"text": "Fetching basic", "progress": 65, "status": 1});
  updateStatus([...statusMessages]);
  
  var basic = await handleBasic(importExactGlobe["impid"], updateStatus);
  await importBasic(case_id, basic);

  statusMessages.push({"text": "Basic records processed: "+ basic.length, "progress": 75, "status": 1});
  updateStatus([...statusMessages]);
  
  statusMessages.push({"text": "Fetching customer supplier", "progress": 80, "status": 1});
  updateStatus([...statusMessages]);

  var customerSupplier = await handleCustomerSupplier(importExactGlobe["impid"], updateStatus);
  await importCustomersupplier(case_id, customerSupplier);

  statusMessages.push({"text": "Customer supplier records processed: "+ customerSupplier.length, "progress": 90, "status": 1});
  updateStatus([...statusMessages]);

  statusMessages.push({"text": "Handling procedure calculations...", "progress": 95, "status": 1});
  updateStatus([...statusMessages]);
  await handleProcedures(case_id, getCookie('factview_access'), importExactGlobe);

  await fetch('/import_exactglobe/updateStamp?id='+data["id"]);

  statusMessages.push({"text": "Import was completed successfully!", "progress": 100, "status": 2});
  updateStatus([...statusMessages]);


  return true;
}

async function initImport(case_id, impid, factviewAccess){
  try{
    const response = await fetch('/exactglobe/initImport', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        case_id: case_id,
        impid: impid,
        factviewAccess: factviewAccess,
      }),
    })
    if (response.ok) {
  
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}
async function fetchTrLines(year){
  try{
    const response = await fetch('http://localhost:3443/api/fetchTrLine', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
       body: JSON.stringify({
        year: year,
      }),
    })
    if (response.ok) {
      const responseData = await response.json();
      return responseData.d.results;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}

async function handleTrLines(case_id, year, impid, ignoreYearEnd, updateStatus){
  var trLines = await fetchTrLines(year);
  // await handleNestedArray(trLines);
  var arr = [];
  statusMessages.push({"text": "TrLines lines fetched: " + trLines.length, "progress": 20, "status": 1});
  updateStatus([...statusMessages]);
  var test1 = [];
  var test2 = []; 
  if(trLines){
    for(const trline of trLines){
      if(trline["FinancialPeriod"] == 1){
        test1.push(trline);
      }
      else if(trline["FinancialPeriod"] == 2){
        test2.push(trline);
      }
    //   if(ignoreYearEnd && (trline["jrndesc"] && trline["jrndesc"].toUpperCase().indexOf("MEMOR") !== -1) && trPeriod == '12' && (trline["oms25"] && (trline["oms25"].indexOf("Result") !== -1 && trline["oms25"].indexOf("Result") === 0) || (trline["oms25"].indexOf("result") !== -1 && trline["oms25"].indexOf("result") === 0) || trline["oms25"].indexOf("Verwerking resultaat"))){
        
      //   }
      //   else{
      //     var dateString = await formatDate(trDate);
          var creditorNumber = (trline["CreditorNumber"]) ? trline["CreditorNumber"].trim() : null;
          var debtorNumber = (trline["DebtorNumber"]) ? trline["DebtorNumber"].trim() : null;
          var custsupid = (debtorNumber)?debtorNumber:creditorNumber;
          var type = (creditorNumber)?'c':'d';
          var date = new Date(trline["EntryDate"].match(/\d+/)[0] * 1);
          var trDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
          var object = {
            "impid": impid,
            "nr": trline["ID"],
            "accid": (trline["GLAccount"])?trline["GLAccount"].trim():trline["GLAccount"],
            "custsupid": custsupid,
            "amnt": trline["Amount"],
            "type": type,
            "costid": trline["CostCenter"],
            "productid": trline["Item"],
            // "jrndesc": trline["jrndesc"],
            "jrnid": (trline["Journal"])?trline["Journal"].trim():trline["Journal"],
            "projectid": trline["Project"],
            "trdesc": trline["Description"],
            "trnr": trline["EntryNumber"],
            "trperiod": trline["FinancialPeriod"],
            "trdate": trDate,
            // "linedesc": trline["oms25"],
            "docnr": trline["DocumentID"], 
            "entiteit":case_id+"_1",
            // "_custsupdesc":trline["cmp_name"],
            "_productdesc":trline[""]
          }
          arr.push(object);
      //   }
        
      // }
    }
    console.log(test1);
    console.log(test2);
    return arr;
  }
  else {
    return false
  }
    
}

async function fetchAccount(){
  try{
    const response = await fetch('http://localhost:3443/api/fetchAccount', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (response.ok) {
      const responseData = await response.json();
      
      return responseData.d.results;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}

async function handleAccount(impid, updateStatus){
  var accounts = await fetchAccount();

  statusMessages.push({"text": "Account records fetched:" + accounts.length, "progress": 35, "status": 1});
  updateStatus([...statusMessages]);
  if(accounts){
    var arr = [];

    for(const account of accounts){
      var type = (account["BalanceProfitAndLoss "] == "B") ? "BAL" : "PNL";
      var object = {
        "impid": impid,
        "accid": (account["GeneralLedgerCode"])?account["GeneralLedgerCode"].trim():account["GeneralLedgerCode"],
        "name": account["GeneralLedgerDescription"],
        "type": type,
      }
      arr.push(object);
    }
    return arr;
  }
  else{
    return false;
  }
}

async function fetchPeriod(year){
  try{
    const response = await fetch('http://localhost:3443/api/fetchPeriod', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        year: year,
      }),
    })
    if (response.ok) {
      const responseData = await response.json();
     
      return responseData.d.results;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}

async function handlePeriod(year, impid, updateStatus){
  var periods = await fetchPeriod(year);
  
  statusMessages.push({"text": "Period records fetched:" + periods.length, "progress": 50, "status": 1});
  updateStatus([...statusMessages]);
  var arr = [];
  if(periods){
    for(const period of periods){
      var dateBegin = new Date(period["DateBegin"].match(/\d+/)[0]);
      var startDate = `${dateBegin.getDate()}-${dateBegin.getMonth()}-${dateBegin.getFullYear()}`;
      var dateEnd = new Date(period["DateEnd"].match(/\d+/)[0]);
      var endDate = `${dateEnd.getDate()}-${dateEnd.getMonth()}-${dateEnd.getFullYear()}`;
     
      var object = {
        "impid": impid,
        "number": (period["FinancialPeriod"])?parseInt(period["FinancialPeriod"].trim()):parseInt(period["FinancialPeriod"]),
        "desc": (period["FinancialPeriod"])?"Periode "+period["FinancialPeriod"].trim():"Periode "+period["FinancialPeriod"],
        "startDate": startDate,
        "endDate": endDate,
      }
      arr.push(object);
    }
    return arr;
  }
  else{
    return false;
  }
  
}


async function fetchCostCenter(){
  try{
    const response = await fetch('http://localhost:3443/api/fetchCostCenter', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (response.ok) {
      const responseData = await response.json();
      
      return responseData.d.results;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}

async function fetchCostUnit(){
  try{
    const response = await fetch('http://localhost:3443/api/fetchCostUnit', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (response.ok) {
      const responseData = await response.json();
      return responseData.d.results;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}

async function fetchProject(){
  try{
    const response = await fetch('http://localhost:3443/api/fetchProject', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (response.ok) {
      const responseData = await response.json();
      return responseData.d.results;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}
async function fetchJournal(){
  try{
    const response = await fetch('http://localhost:3443/api/fetchJournal', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (response.ok) {
      const responseData = await response.json();
      return responseData.d.results;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}

async function fetchProduct(){
  try{
    const response = await fetch('http://localhost:3443/api/fetchProject', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (response.ok) {
      const responseData = await response.json();
      return responseData.d.results;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}

async function handleBasic(impid, updateStatus){
  var costCenters = await fetchCostCenter();
  var costUnits = await fetchCostUnit();
  var projects = await fetchProject();
  var products = await fetchProduct();

  statusMessages.push({"text": "Basic records fetched:" + (costCenters.length + costUnits.length), "progress": 70, "status": 1});
  updateStatus([...statusMessages]);
  
  var arr = [];

  if(costUnits){
    for(const cc of costCenters){
      var object = {
        "impid": impid,
        "id": (cc["Code"])?cc["Code"].trim():cc["Code"],
        "desc": cc["Description"],
        "type": "02",
      }
      if(object.id){
        arr.push(object);
      }
      
    }
  }
  if(costCenters){
    for(const cu of costUnits){
      var object = {
        "impid": impid,
        "id": (cu["Code"])?cu["Code"].trim():cu["Code"],
        "desc": cu["Description"],
        "type": "01",
      }
      if(object.id){
        arr.push(object);
      }
    }
    
  }
  if(projects){
    for(const proj of projects){
      var object = {
        "impid": impid,
        "id": (proj["ProjectNumber"])?proj["ProjectNumber"].trim():proj["ProjectNumber"],
        "desc": proj["Description"],
        "type": "04",
      }
      if(object.id){
        arr.push(object);
      }
    }
  }
  if(products){
    for(const prod of products){
      var object = {
        "impid": impid,
        "id": (prod["ItemCode"])?prod["ItemCode"].trim():prod["ItemCode"],
        "desc": prod["Description0"],
        "type": "03",
      }
      if(object.id){
        arr.push(object);
      }
    }
  }
  return arr;
}

async function fetchCustomerSupplier(){
  try{
    const response = await fetch('http://localhost:3443/api/fetchCustomerSupplier', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (response.ok) {
      const responseData = await response.json();
      
      return responseData.d.results;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}

async function handleCustomerSupplier(impid, updateStatus){
  var customerSupplier = await fetchCustomerSupplier();

  statusMessages.push({"text": "Customer supplier records fetched:" + customerSupplier.length, "progress": 80, "status": 1});
  updateStatus([...statusMessages]);
  if(customerSupplier){
    var arr = [];

    for(const cs of customerSupplier){
      var object = {
        "impid": impid,
        "id": cs["ID"],
        "name": cs["AccountName"],
        "postalcode": cs["InvoiceAddressPostalCode"],
        "city": cs["InvoiceCity"],
        "country": (cs["InvoiceCountry"])?cs["InvoiceCountry"].trim():cs["InvoiceCountry"],
        "entiteit":"",
      }

      arr.push(object);
    }
    return arr;
  }
  else{
    return false;
  }  
}

async function fetchOpeningBalance(year){
  try{
    const response = await fetch('http://localhost:3443/api/fetchOpeningBalance?year='+year, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    if (response.ok) {
      const responseData = await response.json();
     
      return responseData.d.results;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}

async function handleOpeningBalance(year, impid, entiteit, updateStatus){
  var openingBalance = await fetchOpeningBalance(year - 1);

  if(openingBalance){
    var arr = [];
    // for(const ob of openingBalance){
    //   var object = {
    //     "accid": (ob["GeneralLedger"])?ob["GeneralLedger"].trim():ob["GeneralLedger"],
    //     "impid": impid,
    //     "amnt": ob["AmountDC"],
    //     "type": "d",//(ob["AmountDC"] < 0)?"c":"d",
    //     "source": "exactglobe",
    //     "entiteit": entiteit,
    //   }
  
    // arr.push(object);
    // }
    return arr;
  }
  else{
    return false;
  }  
}

async function handleProcedures(case_id, factviewAccess, impid){
  try{
    const response = await fetch('/exactglobe/handleProcedure', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        case_id: case_id,
        factview_access: factviewAccess,
        impid, impid,
      }),
    })
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}

async function handleNestedArray(arr){
  var result = [];
  
  function processNestedArr(input){
   
    if(Array.isArray(input)){
      for(const item of input){ 
        processNestedArr(item);
      }
    }
    else{
      result.push(input);
    }
  }

  processNestedArr(arr);
  return result;
}



